export const TRANSLATIONS_IT = {
  join_eui: "Join EUI",
  app_key: "App Key",
  email: "E-Mail",
  password: "Password",
  forgotpassword: "Hai dimenticato la password?",
  email_field_is_required: "Il campo e-mail è obbligatorio",
  reset_password: "Reimposta password",
  password_field_is_required: "Il campo password è obbligatorio",
  password_do_not_match: "La password non corrisponde",
  invalid_email_address: "Indirizzo e-mail non valido",
  leave_empty_to_keep_current: "Lascia vuoto per mantenere la password corrente",
  enter_email_address: "Inserire indirizzo e-mail",
  create_account: "Crea un account",
  dont_have_an_account: "Non hai un account?",
  already_have_an_account: "Hai già un account?",
  back_to_login: "Torna al login",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Inserisci l'indirizzo e-mail associato al tuo account e ti invieremo un link per reimpostare la tua password.",
  nav: {
    dashboard: "Dashboard",
    inventory: "Inventario",
  },
  inventory: "Inventario",
  inventory_title: "Gestione Inventario",
  add_inventory_item: "Aggiungi articolo",
  edit_inventory_item: "Modifica articolo",
  current_stock: "Scorta attuale",
  low_stock_threshold: "Soglia di scorta in esaurimento",
  low_stock_only: "Solo scorte in esaurimento",
  unit_of_measure: "Unità",
  purchase_link: "Link d'acquisto",
  batch_update_save: "Salva modifiche",
  batch_update_success: "Inventario aggiornato con successo",
  item_created_success: "Articolo creato con successo",
  item_updated_success: "Articolo aggiornato con successo",
  item_deleted_success: "Articolo eliminato con successo",
  item_delete_confirm: "Sei sicuro di voler eliminare questo articolo?",
  dashboard: {
    title: "Dashboard di Produzione",
    total_produced: "Totale prodotto",
    qc_passed_unassigned: "Scorte Attuali",
    all_time: "Tutto il tempo",
    current_year: "Anno corrente",
    all_quarters: "Tutti i trimestri",
    usage_distribution: "Distribuzione dell'utilizzo",
    production_volume: "Volume di produzione",
    qc_passed_only: "Solo QC superato",
  },
  logout: "Disconnettersi",
  user: "Utente",
  users: "Utenti",
  username: "Nome utente",
  save: "Salva",
  name: "Nome",
  login: "Accedi",
  signup: "Registrati",
  delete: "Elimina",
  edit: "Modifica",
  projects: "Progetti",
  trees: "Alberi",
  customers: "Clienti",
  customer: "Cliente",
  address: "Indirizzo",
  confirm: "Conferma",

  sensor_details: {
    empty_sensors: "Nessun sensore, inizia aggiungendo sensori.",
    no_sensor_selected: "Seleziona un sensore per mostrare i dettagli",
    no_data_found: "Nessun dato sensore trovato",
  },
  sensors: "Sensori",
  actions: "Azioni",
  battery: "Batteria",
  threshold: "Soglia",
  settings: "Impostazioni",
  notifications: "Notifiche",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "L'identificazione univoca del sensore. Si trova sull'adesivo del modulo trasmettitore. Per i sensori LoRaWAN è il DevEUI e per i sensori NB-IoT è l'IMEI.",
  imei: "IMEI",
  add_sensor: "Aggiungi sensore",
  add_user: "Aggiungi utente",
  edit_user: "Modifica utente",
  edit_sensor: "Modifica sensore",
  email_notification: "Notifiche via email",
  email_schedule: "Pianificazione email",
  weekly_summary_email: "Email di riepilogo settimanale",
  daily_changes_email: "Email delle modifiche giornaliere",
  manage_users_description: "Gestisci account utente e permessi",
  manage_customers_description: "Gestisci informazioni clienti e accesso",
  statistics: "Statistiche",
  customer_statistics_description: "Visualizza statistiche clienti e panoramica dati",

  sensor_status_change_to_no_connection: "Cambio stato sensore a 'nessuna connessione'",
  sensor_status_change_to_dry: "Cambio stato sensore a 'secco'",
  sensor_status_change_to_drying_out: "Cambio stato sensore a 'in via di asciugatura'",
  error: {
    this_field_is_required: "Questo campo è obbligatorio",
    something_went_wrong: "Qualcosa è andato storto",
    loading_customers: "Errore durante il caricamento dei clienti",
    loading_users: "Errore durante il caricamento degli utenti",
  },
  error_label: "Errore",
  first_name: "Nome",
  last_name: "Cognome",
  profile: "Profilo",

  phone_number: "Numero di telefono",
  account_type: "Tipo di account",
  city: "Città",
  street_name: "Nome della strada",
  house_number: "Numero civico",
  country: "Paese",
  zip_code: "Codice postale",
  day: {
    mon: "Lunedì",
    tue: "Martedì",
    wed: "Mercoledì",
    thu: "Giovedì",
    fri: "Venerdì",
    sat: "Sabato",
    sun: "Domenica",
  },
  admin: "Admin",
  basic: "Base",
  superuser: "Superutente",
  export: "Esporta",
  select_customer_type: "Seleziona tipo di cliente",
  customer_type: "Tipo di cliente",
  change_image: "Cambia immagine",
  update_image: "Aggiorna immagine",
  update_customer_logo_description: "Carica e aggiorna il logo della tua organizzazione",
  change_language: "Cambia lingua",
  time: "Tempo",
  resistance: "Resistenza",
  search_sensor: "Cerca sensore",
  download_sensor_data: "Scarica dati del sensore",
  temperature: "Temperatura",
  loading: "Caricamento...",
  button: {
    back: "Indietro",
    next: "Avanti",
    save: "Salva",
    reset: "Reimposta",
    saving: "Salvando...",
    update: "Aggiorna",
    updating: "Aggiornando...",
    add_sensor: "Aggiungi sensore",
    add_customer: "Aggiungi cliente",
    edit_customer: "Modifica cliente",
    cancel: "Annulla",
    discard: "Scarta",
  },

  user_form: {
    profile: "Profilo",
    address: "Indirizzo",
    basic_info: "Informazioni di base",
    login_credentials: "Credenziali di accesso",
    areas: "Aree",
  },
  sensor_form: {
    name: "Nome",
    threshold: "Soglia",
    hardware_serial: "Numero di serie hardware",
    sensor_type: "Tipo di sensore",
    network_type: "Tipo di rete",
  },
  area_form: {
    existing_area: "Area esistente",
  },
  add_all_form: {
    title: "Aggiungi Albero e Sensore in Area",
    sensor: {
      title: "Sensore",
      explanation:
        "Qui puoi creare un nuovo sensore da aggiungere all'albero, oppure selezionare un sensore esistente da aggiungere.",
      new_sensor: "Crea un nuovo sensore",
      existing_sensors: "Aggiungi sensori esistenti",
    },
    tree: {
      title: "Albero",
      explanation: "Qui puoi creare un nuovo albero o selezionarne uno esistente.",
      new_tree: "Crea un nuovo albero",
      existing_tree: "Seleziona un albero esistente",
    },
    area: {
      title: "Area",
      explanation:
        "Qui puoi creare una nuova area o selezionarne una esistente a cui aggiungere l'albero.",
      new_area: "Crea una nuova area",
      existing_area: "Seleziona un'area esistente",
    },
  },
  new_area: "Nuova area",
  existing_area: "Area esistente",
  explanation: "Spiegazione",
  create_new_tree: "Crea nuovo albero",
  validation: {
    email_is_required: "L'email è richiesta",
    password_is_required: "La password è richiesta",
    invalid_email_address: "Indirizzo email non valido",
    name_is_required: "Il nome è richiesto",
    hardware_serial_is_required: "Il numero di serie hardware è richiesto",
    user_with_this_email_already_exist: "Un utente con questa email esiste già",
    all_address_field_are_required: "Tutti i campi dell'indirizzo sono richiesti",
    position_is_required: "La posizione è richiesta",
    invalid_house_number: "Numero di casa non valido",
    user_limit_exceeded_for_your_package: "Limite di utenti superato per il vostro pacchetto",
    sensor_limit_exceeded_for_your_package: "Superamento del limite del sensore per il pacchetto",
    imei_must_be_15_digits: "L'IMEI deve contenere esattamente 15 cifre.",
    hardware_serial_must_be_16_characters:
      "Il numero di serie dell'hardware deve essere esattamente di 16 caratteri.",
    must_be_a_number: "Il valore deve essere un numero",
    out_of_range: "Il valore deve essere compreso tra {{min}} e {{max}}",
  },
  drag_the_below_variables_to_graph_area: "Trascina le variabili sottostanti nell'area del grafico",
  drop_left: "Rilascia a sinistra",
  drop_right: "Rilascia a destra",
  drop_the_variable_to_get_data: "Rilascia la variabile per ottenere i dati",
  no_data_available_please_check_data_available_to_this_date:
    "Nessun dato disponibile, si prega di controllare i dati disponibili a questa data",
  unable_to_upload_file: "Impossibile caricare il file",
  file_upload_successfully: "File caricato con successo",
  no_tree_is_selected: "Nessun albero selezionato",
  no_sensor_is_selected: "Nessun sensore selezionato",
  areaName: "Nome dell'area",
  childTree: "Albero secondario",
  add_child_tree: "Aggiungi albero secondario",
  parentTree: "Albero principale",
  area: "Area",
  areas: "Aree",
  add_area: "Aggiungi area",
  start_with_adding_new_project: "Inizia aggiungendo un nuovo progetto",
  resis_temp_comp: "Compensazione temperatura resis",
  health_of_tree_is_good: "La salute dell'albero è buona",
  health_of_tree_is_drying_out: "La salute dell'albero si sta esaurendo",
  health_of_tree_is_poor: "La salute dell'albero è scarsa",
  sensor_disconnect: "Sensore disconnesso",
  battery_full: "Batteria piena",
  less_than_60_of_the_battery_remaining: "Meno del 60% della batteria rimanente",
  battery_is_getting_low: "La batteria si sta esaurendo",
  size: "Dimensione",
  type: "Tipo",
  map_view: "Vista mappa",
  records: "Record",
  status: "Stato",
  welcome_back: "Bentornato!",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Sembra che tu non abbia selezionato un'area, seleziona un'area per ottenere i dati",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Sembra che tu non abbia selezionato un albero, seleziona un albero per ottenere i dati",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Sembra che tu non abbia selezionato un sensore, seleziona un sensore per ottenere i dati",
  please_drag_the_variable_to_display_data: "Trascina la variabile per visualizzare i dati",
  click_on_marker_to_select_tree: "Clicca sul marcatore per selezionare l'albero",
  next_irrigation: "Prossima irrigazione",
  mean: "Media",
  sensor_state: "Stato del sensore",
  state: "Stato",
  moisture_content: "Indice di umidità Treesense",
  card_number: "Numero della carta",
  card_name: "Nome sulla carta",
  expiration_date: "Data di scadenza",
  continue: "Continua",
  today: "Oggi",
  tomorrow: "Domani",
  days_left: "giorni rimasti",
  days: "Giorni",
  personal_data: "Dati personali",
  language: "Lingua",
  saved: "Salvato",
  payment: "Pagamento",
  benifits: "Benefici",
  change_logo: "Cambia logo",
  role: "Ruolo",
  demo_project_warning: {
    title: "Account Demo",
    description:
      "Stai utilizzando un account demo e hai diritti limitati. Se sei già un cliente e desideri accedere al tuo account cliente, contatta il supporto all'indirizzo support@treesense.net. Se non sei ancora un cliente, puoi ordinare sensori tramite il nostro negozio su https://www.treesense.net.",
  },
  image_upload_info: {
    title: "Caricamento di immagini degli alberi possibile",
    description:
      "Per ottimizzare la nostra formula di salute dell'albero sui tuoi alberi, offriamo la possibilità di caricare immagini del tuo albero nell'elenco degli alberi.",
  },
  add_tree_img: "Carica immagini dell'albero",
  datetime_photo: "Data e ora della foto",
  upload_tree_img: "Carica immagine dell'albero",
  upload_leaf_img: "Carica immagine della foglia",
  pulse_sensor: "Sensore a impulsi",
  soil_moisture_sensor: "Sensore di umidità del suolo",
  dendrometer_sensor: "Dendrometro",
  here: "qui",
  characters: "Caratteri",
  maximum_of: "Massimo",
  stop_scanning: "Interrompere la Scansione",
  last_measurements: "Ultime misurazioni",
  adjust_thresholds_crown: "Regolazione delle soglie dei sensori a corona",
  adjust_thresholds_soil: "Regolare le soglie dei sensori del terreno",
  set_default: "Impostare l'impostazione predefinita",
  meaning_measurement: "Significato della misura",
  download_tree_list: "Scarica l'elenco degli alberi",
  download_tree_details: "Scarica i dettagli dell'alberi",
  not_provided: "Non fornito",
  soil_moisture_edit: "Valori limite umidità vol. del suolo",
  soil_water_tension_edit: "Valori limite per la tensione di aspirazione del terreno",
  select_language: "Seleziona la Lingua",
  network_type: "Tipo di rete",
  sensor_type: "Tipo di sensore",
  lora_wan: "LoRaWAN",
  nb_iot: "NB-IoT",
  battery_empty: "Batteria scarica",
  maintenance_needed: "Manutenzione necessaria",
  All: "Tutti",
  tree_count: "Numero di alberi",
  soil_moisture: "Umidità del suolo",
  soil_water_tension_sensor: "Sensore di tensione di suzione del suolo",
  soil_water_tension: "Tensione di suzione del suolo",
  views_per_page: "Visite per pagina",
  customer_attributes: "Attributi cliente",
  paid: "Pagato",
  maintenances: "Lavori di manutenzione",
  add_maintenance: "Aggiungere lavoro di manutenzione",
  list_maintenances: "Elenco delle manutenzioni precedenti",
  tree_profile: {
    tree_species_knowledge: "Fatti",
    tree_species: "Curiosità",
    tree_info: "Informazioni sull'albero",
    want_to_know_more: "Vuoi saperne di più?",
    learn_more: "Clicca qui per saperne di più",
  },
  root_system: {
    UN: "Sconosciuto",
    SH: "Radici superficiali",
    DE: "Radici profonde",
    HE: "Radici a cuore",
  },
  latin_name: "lat. Nome",
  german_name: "dt. Nome",
  tree_species: "Specie dell'albero",
  depth: "Profondità",
  healthy: "Sano",
  not_sending: "Non invia dati",
  working: "Funziona",
  unknown: "Sconosciuto",
  amount_nodes: "Numero di nodi sensore",
  add_installation: "Creare installazione",
  select_sensor: "Selezionare sensore",
  select_depth: "Selezionare profondità",
  installed_at: "Data di installazione",
  removed_at: "Data di rimozione",
  last_battery: "Ultimo valore della batteria",
  hardware_serial_no: "Hardware Seriale",
  required_information: "* Informazioni obbligatorie",
  last_10_measurements: "Ultimi 10 valori misurati",
  soil_name: "Nome del suolo",
  optional_soil_name: "Nome del suolo (opzionale)",
  tree_name: "Nome dell'albero",
  soil: "Suolo",
  permanent_wilting_point: "Punto di appassimento permanente",
  effective_field_capacity: "Capacità di campo utile",
  field_capacity: "Capacità di campo",
  sensor_status: "Stato del sensor",
  sensor_status_description:
    "Lo stato del sensore indica se il sensore funziona o se necessita di manutenzione, ad esempio.",
  download_success: "Download completato con successo.",
  download_failed: "Download non riuscito. Riprova.",
  timeframe: "Intervallo di tempo",
  timeframe_hint:
    "Lascia invariato per scaricare gli ultimi 30 giorni. Modifica l'intervallo per restringere l'esportazione.",
  invalid_date_range: "La data di inizio deve essere precedente alla data di fine.",
  tui: "TUI",
  assign_sensor: "Assegna sensore",
  create_customer: "Crea cliente",
  customer_info: "Informazioni cliente",
  customer_name_or_cloud_id: "ID o Nome del cliente",
  download_csv: "Scarica dati del progetto (file TSV)",
  download_project_data: "Scarica tutti i dati dei sensori del progetto",
  enter_customer_name: "Inserisci ID o nome del cliente",
  enter_customer_name_or_cloud_id: "Inserisci il nome del cliente o l'ID Cloud",
  enter_domain: "Inserisci dominio",
  enter_name: "Inserisci nome",
  package: "Pacchetto",
  usage: "Tipo di utilizzo",
  calculated_values_wip:
    "I valori calcolati (moisture_content, resis_temp_comp) sono ancora in fase di sviluppo. Si prega di utilizzarli con cautela. Seleziona se desideri scaricare anche i valori calcolati.",
  comments: "Commenti",
  created_at: "Creato il",
  enter_tui_part_placeholder: "Inserisci parte del TUI (ad es. A84041AA)",
  failed: "Fallito",
  include_calculated_values: "Includi valori calcolati",
  multiple_sensors_found: "Trovati più sensori",
  multiple_sensors_found_message:
    "Più sensori corrispondono alla tua ricerca. Clicca su uno dei TUI sottostanti per selezionarlo.",
  no_sensor_events_found: "Nessun evento sensore trovato per questo sensore.",
  qc_passed: "Controllo qualità superato",
  passed: "Superato",
  search: "Cerca",
  searching: "Ricerca in corso...",
  sensor_events: "Eventi sensore",
  no_sensors_found: "Nessun sensore trovato",
  sensor_not_found: "Sensore non trovato",
  sensor_not_found_message: "Nessun sensore trovato con la parte TUI fornita.",
  customer_not_found: "Cliente non trovato",
  customer_not_found_message: "Nessun cliente trovato con l'ID cloud o il nome fornito.",
  last_sensor_event: "Ultimo evento sensore",
  tui_part: "Parte del TUI",
  tui_search_help: "Inserisci una parte del TUI del sensore per cercare",
  variables: "Variabili / Valori",
  sensor_list: "Elenco sensori",
  sensor_lookup: "Produzione",
  manual: {
    sign_up: {
      title: "Registrazione",
      list: {
        1: "Registrati su cloud.treesense.net",
        2: "Avvisa il [supporto clienti](mailto:support@treesense.net)",
      },
    },
    add_sensor: {
      title: "Crea un sensore/progetto",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    view_data: {
      title: "Visualizza i dati del sensore",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    irrigation: {
      title: "Prossima irrigazione",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    api: {
      title: "Interface/API",
      description:
        "La documentazione dell’interfaccia è disponibile [qui](https://api.treesense.net/docs).",
    },
  },
  leih: "Prestito",
  none: "Nessuno",
  qr_Scanner: "Scanner QR",
  selectcamera: "Seleziona fotocamera",
  sensorevent: "Evento sensore",
  cloud_id: "ID cloud",
  creating: "Creazione in corso",
  customer_created_successfully: "Cliente creato con successo",
  customer_creation_failed: "Creazione del cliente non riuscita",
  customer_creation_code: "Codice di creazione cliente",
  customer_name: "Nome cliente",
  customer_sensors: "Sensori del cliente",
  domain: "Dominio",
  enter_cloud_id: "Inserisci l'ID cloud",
  enter_comments: "Inserisci i commenti",
  fetch: "Recupera",
  fetching: "Caricamento in corso...",
  last_created_customer: "Ultimo cliente creato",
  lorawan_keys_fetch_failed: "Recupero delle chiavi LoRaWAN non riuscito",
  lorawan_keys_list: "Elenco delle chiavi LoRaWAN",
  lost: "Perso",
  no_change: "Nessuna modifica",
  no_lorawan_keys_found: "Nessuna chiave LoRaWAN trovata",
  not_found: "Non trovato",
  projects_views: "Progetti",
  rented: "Noleggiato",
  replaced: "Sostituito",
  research: "Ricerca",
  sensor_assigned_successfully: "Sensore assegnato con successo",
  sensor_assignment_failed: "Assegnazione del sensore non riuscita",
  sensors_views: "Sensori",
  sold: "Venduto",
  assigned_from_date: "Assegnato da (opzionale)",
  assigned_from_date_help: "Lascia vuoto per iniziare da oggi",
  assigned_until_date: "Assegnato fino a (opzionale)",
  assigned_until_date_help: "Lascia vuoto per assegnazione indefinita",
  optional: "Opzionale",
  search_sensors: "Cerca sensori per nome, DevEUI o IMEI...",
  showing_results: "Mostrando {{count}} risultato/i",
  close: "Chiudi",
  more_actions: "Altre azioni",
  start_scanning: "Avvia scansione",
  trees_views: "Alberi",
  unknown_customer: "Cliente sconosciuto",
  update_sensor_values: "Aggiorna valori sensore",
  download: "Scarica",
  sensor_return: "Restituzione sensore",
  sensor_return_title: "Restituisci sensore al magazzino",
  sensor_return_description:
    "Disassocia un sensore dal cliente attuale impostando la data di restituzione. Questo terminerà automaticamente l'assegnazione corrente.",
  sensor_return_tui_help: "Inserisci il TUI per identificare il sensore",
  return_date: "Data di restituzione",
  return_date_help: "Data in cui il sensore è stato restituito",
  return_date_help_default_today:
    "Data in cui il sensore è stato restituito, se lasciato vuoto, verrà utilizzata la data di oggi",
  unassign_sensor: "Restituisci sensore",
  sensor_returned_successfully: "Sensore restituito con successo",
  sensor_return_failed: "Impossibile restituire il sensore",
  success: "Successo",
  currently_assigned_to: "Attualmente assegnato a",
  assigned_since: "Assegnato dal",
  sensor_not_assigned_to_customer: "Questo sensore non è attualmente assegnato ad alcun cliente.",
  manage_customers: "Gestisci i clienti",
  customer_details: "Dettagli cliente",
  customer_id: "ID cliente",
  total_sensors: "Sensori totali",
  total_probes: "Sonde totali",
  customer_sensors_list: "Elenco sensori cliente",
};
